import { MsgService } from './../share/msg/msg.service';
import { UtilService } from './../share/util/util.service';
import { Injectable } from '@angular/core';
import { IItadakimasu } from '../scan-card/itadakimasu/itadakimasu-if';
import { IItadakimasuError } from './scan-card-error-handler/itadakimasu-error-if';
import { Condition } from '../error/cognito-error-enums';
import * as MSG from '../share/msg/msg';

@Injectable()
export class CognitoErrorHandlerService {

  constructor(
    private utilServ: UtilService,
    private msgServ: MsgService,
  ) { }

  /** Cognitoが返す例外を表示。 refs: https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/Welcome.html
   * @param {string} errorCode Cognitoが返すエラーコード
   * @param {Condition} condition メソッド呼び出し時の状態
   */
  public handleCognitoError(errorCode: string, condition: Condition, messageByCognito: string): void {
    // 開発者用ログ出力
    console.error('errorCode: ', errorCode);
    console.error('condition: ', condition);
    console.error('messageByCognito: ', messageByCognito);

    switch (errorCode) {
      case 'NotAuthorizedException':
        if (condition === Condition.whenSignIn) {
          this.msgServ.warning(MSG.WARNING.INCORRECT_USERNAME_OR_PASSWORD, '');
        } else if (condition === Condition.whenChangePassword) {
          this.msgServ.warning(MSG.WARNING.INCORRECT_CURRENT_PASSWORD, '');
        } else if (condition === Condition.whenChangePasswordFirst) {
          this.msgServ.warning(MSG.WARNING.INCORRECT_USERNAME_OR_PASSWORD, '');
        } else if (condition === Condition.whenForgotPasswordSubmit) {
          this.msgServ.warning(MSG.WARNING.INCORRECT_USERNAME_OR_PASSWORD, '');
        } else {
          this.msgServ.warning(MSG.WARNING.INCORRECT_USERNAME_OR_PASSWORD, '');
        }
        break;
      case 'LimitExceededException':
        this.msgServ.warning(MSG.WARNING.ATTEMPT_LIMIT_EXCEEDED, '');
        break;
      case 'CodeMismatchException':
        this.msgServ.warning(MSG.WARNING.INCORRECT_CODE, '');
        break;
      case 'CodeDeliveryFailureException':
        this.msgServ.warning(MSG.WARNING.FAIL_COMMUNICATION, '');
        break;
      case 'ExpiredCodeException':
        this.msgServ.warning(MSG.WARNING.EXPIRED_CODE, '');
        break;
      case 'UserNotFoundException':
        this.msgServ.warning(MSG.WARNING.NOT_EXIST_DATA('ご指定のサインインID'), '');
        break;
      case 'InvalidEmailRoleAccessPolicyException':
        this.msgServ.error(MSG.DANGER.S0, '');
        break;
      case 'AliasExistsException':
        if (condition === Condition.whenSignUp) {
          this.msgServ.warning(MSG.WARNING.DUPLICATE('メールアドレス'), '');
        }
        break;
      case 'InvalidParameterException':
        this.msgServ.error(MSG.WARNING.INCORRECT_USERNAME_OR_PASSWORD, '');
        break;
      case 'InvalidPasswordException':
        this.msgServ.warning(MSG.WARNING.INVALID_PASSWORD, '');
        break;
      case 'PasswordResetRequiredException':
        this.msgServ.error(MSG.DANGER.S0, '');
        break;
      case 'ResourceNotFoundException':
        this.msgServ.error(MSG.DANGER.S0, '');
        break;
      case 'TooManyRequestsException':
        this.msgServ.warning(MSG.WARNING.TOO_MANY_REQUEST, '');
        break;
      case 'TooManyFailedAttemptsException':
        this.msgServ.warning(MSG.WARNING.FAIL_COMMUNICATION, '');
        break;
      case 'UserNotConfirmedException':
        this.msgServ.warning(MSG.WARNING.NOT_EXIST_DATA('ユーザ情報'), '');
        break;
      case 'InvalidLambdaResponseException':
        this.msgServ.error(MSG.DANGER.S0, '');
        break;
      case 'UnexpectedLambdaException':
        this.msgServ.error(MSG.DANGER.S0, '');
        break;
      case 'UserLambdaValidationException':
        this.msgServ.error(MSG.DANGER.S0, '');
        break;
      case 'ConfigError':
        this.msgServ.error(MSG.DANGER.S0, '');
        break;
      case 'InternalErrorException':
        this.msgServ.error(MSG.DANGER.S500_INTERNAL_SERVER_ERROR, '');
        break;
      case 'NetworkError':
        this.msgServ.error(MSG.DANGER.CANT_CONNECT_API, '');
        break;
      default:
        this.msgServ.error(MSG.DANGER.S0, '');
        break;
    }
  }
}
